import type { JsonObject } from "type-fest";
import { z } from "zod/v4";

import { type PageMetadata } from "@moment/api-collab/api-types";

// Re-export PageMetadata for convenience
export type { PageMetadata };

export type PageMetadataWithIndex = PageMetadata & {
	/** The position to insert this page in the metadata pages array on the server. */
	pageIndex?: number;
};

/** Minimal empty ProseMirror document JSON. Use when creating placeholder page content. */
export const EMPTY_DOC_JSON = {
	type: "doc",
	content: [{ type: "paragraph", content: [] }],
} as const;

export type PageContentSource = "disk" | "remote";

export const StoredPageSchema = z.object({
	doc: z.custom<JsonObject>(),
	metadata: z.custom<PageMetadata>(),
});

export type StoredPage = z.infer<typeof StoredPageSchema>;

export type PageContentResult = {
	content: StoredPage;
	source: PageContentSource;
	raw?: string; // Raw markdown for markdown pages
};

export type CanvasSnapshot = {
	store: Record<string, unknown>;
	schema: {
		schemaVersion: number;
		storeVersion: number;
	};
};

export type HttpRequestPage = {
	request: {
		method: string;
		url: string;
		headers: Array<{ key: string; value: string }>;
		body: {
			mode: "none" | "json" | "text" | "html" | "form" | "form-urlencoded" | "xml";
			text: string;
		};
	};
};

/**
 * Content needed to create a ProseMirror EditorState
 * Use with createEditorState() from @moment/app
 */
export type PageEditorContent = {
	documentId: string;
	pageId: string;
	doc: any; // ProseMirror doc JSON
	source: PageContentSource;
};
